import React from "react";
import { useState } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { getRoot } from "./helpers";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { redirectFromIframe } from "./utils";
import Footer from "./Footer";
import SynIceCalc from "./SynIceCalc";
import RinkCalc from "./RinkCalc";
import InquiryForm from "./InquiryForm";
import { Button } from "react-bootstrap";

const options = [
  { value: 0, label: "Input the minimum dimension I want" },
  { value: 1, label: "Input the maximum dimensions I can fit" },
  {
    value: 2,
    label:
      "Input my current EZ ICE Rink Size so I can use my rink with synthetic ice",
  },
  { value: 3, label: "Manually select how many panels I want" },
];

function RinkForm(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [province, setProvince] = useState("");
  const [phone, setPhone] = useState("");
  const [contactMethod, setContactMethod] = useState("Email");
  const [size, setSize] = useState("");
  const [style, setStyle] = useState("");
  const [location, setLocation] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const rinkType = toTitleCase(props.product.replace(/_/g, " "));

  async function handleSubmit(event) {
    event.preventDefault();

    if (!name || !email || !province || !phone) {
      toast.error("Please make sure all fields are completed.");
      return;
    }

    setSubmitted(false);

    const payload = {
      name,
      email,
      province,
      phone,
      contactMethod,
      size,
      style,
      location,
      rinkType,
    };
    try {
      const response = await axios.post(
        `${getRoot()}/api/shopify/submit_rink_form`,
        payload
      );
      if (response.status < 400) {
        toast.success("Message sent successfully!");
        setSubmitted(true);
      } else {
        toast.error(
          "Submission unsuccessful - Please make sure all fields are completed."
        );
      }
    } catch (error) {
      console.error(error);
      toast.error(
        "Submission unsuccessful - Please make sure all fields are completed."
      );
    }
  }

  function goToCart() {
    window.parent.postMessage(
      {
        goToCart: true,
      },
      "*"
    );
  }

  return (
    <div className="bk2:mb-[100px]">
      <div className="flex flex-col pt-8 pb-1 bg-cover bg-no-repeat bg-center justify-center items-center">
        <div className="flex flex-col text-lg text-center mb-4">
          <div className="text-4xl bk5:text-3xl font-bold text-center">
            {rinkType === "Synthetic Ice Rink"
              ? "Synthetic Ice Rink Builder"
              : "Street Hockey Rink Builder"}
          </div>
          <div className="flex justify-center mt-2 bk8:text-sm">
            Looking to build a (REAL) Ice Rink? Go to the
            <a
              className="cursor-pointer underline font-bold ml-1"
              onClick={() =>
                redirectFromIframe(
                  "https://ezicerinks.com/pages/ez-ice-rink-builder"
                )
              }
            >
              Ice Rink Builder
            </a>
          </div>
        </div>

        <div className="flex bk7:flex-col bk7:justify-center mx-2">
          <div>
            <div className="flex flex-col items-center justify-center border-4 border-black p-2 rounded-xl">
              <RinkCalc rinkType={rinkType} />
            </div>

            <div className="mb-2 bk8:text-xs p-2">
              *Free shipping on rink orders over $1500! Free shipping not
              available on Synthetic Ice or Ultra Base and limitations may apply
              to AK and Canada orders.
            </div>
            {rinkType !== "Synthetic Ice Rink" && (
              <Button
                className="mb-2 bk7m:ml-4 bg-[#2C70B3] hover:bg-ezice-blue-800 p-2 text-lg w-40 font-bold text-white rounded-xl"
                onClick={goToCart}
              >
                Go to Cart
              </Button>
            )}
          </div>

          {rinkType === "Synthetic Ice Rink" && (
            <div className="flex flex-col">
              <div className="flex flex-col bk7m:min-h-[900px] border-4 border-black px-2 pt-2 pb-[80px] rounded-xl bk7:mt-4 bk7m:ml-4 bg-gray-100 relative">
                <SynIceCalc />
              </div>
              <Button
                className="mt-3 bk7m:ml-4 bg-[#2C70B3] hover:bg-ezice-blue-800 p-2 text-lg w-40 font-bold text-white rounded-xl"
                onClick={goToCart}
              >
                Go to Cart
              </Button>
            </div>
          )}
        </div>
      </div>

      <InquiryForm rinkType={rinkType} />
      <Footer />
    </div>
  );
}

function toTitleCase(str) {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export default RinkForm;
